module.exports = __webpack_public_path__ + "static/media/io.b72e133f.webp";